import { CustomActions, CustomState } from "@gerrieDev/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import React, { useState } from "react";
import { connect, DispatchProp } from "react-redux";
import { css } from "styled-components";

const accordionStyles = {
    css: css`
        background: transparent;
        margin-bottom: 2rem;
        border: none;
        span {
            color: #046faf;
        }
        button {
            background: transparent !important;
            border: 1px solid black;
        }
        dd {
            border: none;
        }
    `,
};
// Testing
const inputStyles = {
    css: css`
        padding-bottom: 1rem;
        input {
            width: 1.3em;
            height: 1.3em;
            background-color: white;
            border-radius: 50%;
            vertical-align: middle;
            border: 1px solid black;
            -webkit-appearance: none;
            outline: none;
            cursor: pointer;
            margin-right: 1rem;
            &:checked {
                background-color: #046faf;
                border: 1px solid #046faf;
            }
        }
    `,
};

const enum fields {
    solutionDisplayName = "solutionDisplayName",
    solutionType = "solutionType",
    accordionTitle = "accordionTitle",
    solutions = "solutions",
}

type solutionModel = {
    fields: {
        [fields.solutionDisplayName]: string;
        [fields.solutionType]: string;
    };
};

type MyProps = {
    fields: {
        [fields.accordionTitle]: string;
        [fields.solutions]: solutionModel[];
    };
};

type Props = MyProps & ReturnType<typeof mapStateToProps> & DispatchProp<CustomActions>;

const solutionAccordion: React.FC<Props> = ({ dispatch, solutionsArr, fields: { solutions, accordionTitle } }: Props) => {
    const solutionMap = new Map<string, boolean>();

    solutions.map(solution => {
        solutionMap.set(solution.fields.solutionType, solutionsArr.includes(solution.fields.solutionType));
    });

    const togglesolutionMap = (key: string) => {
        solutionMap.set(key, !solutionMap.get(key));
    };

    const filterMap = (solutionMap: Map<string, boolean>) => {
        const filteredArr: string[] = [];
        solutionMap.forEach((value: boolean, key: string) => {
            if (solutionMap.get(key)) {
                filteredArr.push(key);
            }
        });
        return filteredArr;
    };

    return (
        <StyledWrapper>
            <StyledWrapper {...accordionStyles}>
                <Accordion headingLevel={5}>
                    <AccordionSection title={accordionTitle}>
                        {solutions.map((solution, index) => (
                            <StyledWrapper {...inputStyles}>
                                <input
                                    type="checkbox"
                                    onClick={() => {
                                        togglesolutionMap(solution.fields.solutionType);
                                    }}
                                />
                                <label>{solution.fields.solutionDisplayName}</label>
                            </StyledWrapper>
                        ))}
                    </AccordionSection>
                </Accordion>
            </StyledWrapper>

            <Button
                onClick={() => {
                    dispatch({ type: "Custom/Traditional/AddSolutions", solutions: filterMap(solutionMap) });
                }}
                color="#F06907"
                buttonType="outline"
            >
                {" "}
                Submit{" "}
            </Button>
        </StyledWrapper>
    );
};

const mapStateToProps = (state: CustomState) => ({
    solutionsArr: state.addSolutionsReducer.solutions,
});

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(solutionAccordion),
    definition: {
        group: "Basic",
        icon: "Link",
        fieldDefinitions: [
            {
                name: fields.accordionTitle,
                fieldType: "General",
                editorTemplate: "TextField",
                displayName: "Accordion Title",
                defaultValue: "",
            },
            {
                name: fields.solutions,
                editorTemplate: "ListField",
                // tab: contentTab,
                getDisplay: ({ fields: { solutionDisplayName } }) => solutionDisplayName || "solutions",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: fields.solutionType,
                        editorTemplate: "TextField",
                        displayName: "solution Type",
                        defaultValue: "",
                    },
                    {
                        name: fields.solutionDisplayName,
                        editorTemplate: "TextField",
                        displayName: "solution Display Name",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
